module.exports = __webpack_public_path__ + "media/images/shared/ad/muevo_campaign_create-db98ef93ab2033899e1b7146b3b6fadb.png";